import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Partner } from '../../models/partner';

@Component({
  selector: 'app-partner-info',
  templateUrl: './partner-info.component.html',
  styleUrls: ['./partner-info.component.css']
})
export class PartnerInfoComponent implements OnInit {

  @Input() partner: Partner;

  @Output() goToPartnerOrders = new EventEmitter();
  @Output() downloadWaiver = new EventEmitter();
  @Output() deleteAccount = new EventEmitter();
  @Output() eventManageChildrenData = new EventEmitter();
  @Output() eventMyProfile = new EventEmitter();

  constructor() { }

  ngOnInit() {
    if (this.partner === undefined) {
      this.partner = new Partner();
    }
  }

  bookingOverviewClick() {
    this.goToPartnerOrders.emit();
  }

  downloadWaiverClick() {
    this.downloadWaiver.emit();
  }

  deleteAccountClick() {
    this.deleteAccount.emit();
  }

  myChildrenClick() {
    this.eventManageChildrenData.emit();
  }

  myProfileClick() {
    this.eventMyProfile.emit();
  }
}
